import React, {DetailedHTMLProps, useCallback, useContext, useState} from 'react'
import {BiInfoCircle} from 'react-icons/bi'
import {useNavigate} from 'react-router-dom'
import RegisterOscContext from '../../../context/RegisterContext'
import {Button} from '../../../Korbantech/components/Buttons/Button'
import Modal from '../../../Korbantech/components/Modal'
import {Osc} from '../../../types/Osc'
import {TextInput} from "../../../Korbantech/components/Inputs/TextInput";


export const UrlInput = React.forwardRef<HTMLInputElement, Props>(({
                                                                       cad,
                                                                       label,
                                                                       important,
                                                                       necessary,
                                                                       info,
                                                                       oldValue,
                                                                       ...props
                                                                   }, ref) => {

    const navigate = useNavigate()

    const [url, setUrl] = useState<string>("")
    const [modal, setModal] = useState<boolean>(false)
    const [modalInfo, ] = useState<{ text: string, buttonText: string } | undefined>(undefined)
    const {setOsc} = useContext(RegisterOscContext)
    const [tmpOsc, ] = useState<Osc>()

    const actionModal = useCallback(() => {
        if (!tmpOsc) return navigate("/osc/login")
        setOsc(tmpOsc)
        setModal(false);
    }, [tmpOsc, setOsc, navigate])

    return (
        <div className=''>
            <label className='flex justify-between'>
                <div className='flex items-center'>
                    {label}
                    {important && <BiInfoCircle className='text-primary-dark ml-1'/>}
                </div>
                {!necessary && <div className='text-sm italic '>opcional</div>}
            </label>
            <TextInput
                required
                value={'https://' + url.replace('http://', '').replace('https://', '')}
                onChange={(e: { target: { value: React.SetStateAction<string> } }) => setUrl(e.target.value)}
                name={props.name}
                className="w-full focus:outline-none h-10 border px-2"/>
            <div className='text-gray-500 text-sm'>{info}</div>
            <Modal open={modal} onClickCloseButton={() => setModal(false)}>
                <div>
                    {modalInfo?.text}
                    <Button value={modalInfo?.buttonText} onClick={actionModal}/>
                </div>
            </Modal>
        </div>
    )
})

interface Props extends DetailedHTMLProps<any, HTMLInputElement> {
    label: string,
    important?: boolean,
    necessary?: boolean
    info?: string
    oldValue?: string
    cad?: boolean
}
